
    <header class="shadow  rounded  bg-light">
      <div class="row">
      <div class="col-4">
         <img [src]="logoImage" class="img-fluid" alt="LA header logo picture"/>
      </div>
      <div class="col">
        <h1 class=" fw-bold">
          Louisiana HIPP Program Online Application</h1>

        <div  class="fw-bold" style="padding-left: 90px;">Fill out this form and click Submit to apply.</div>

        <p role="heading" aria-level="1">If you prefer to download a Louisiana HIPP Program Application
          <a href="javascript:void(0)" (click)="openPaperApplication()" class="anchor" lang="en"  download aria-label="download Louisiana HIPP Program Application">download application</a></p>
          <!-- <div class="fw-bold" style="padding-left: 90px;"> -->
             <p class="fw-bold justified-text">By participating in LaHIPP, you understand and agree that the Medicaid members will no longer
             receive their physical health services from a Healthy Louisiana managed care plan. Physical health services that are not covered by your private health insurance plan may be
           covered by Louisiana Medicaid fee-for-service program. The Medicaid members will continue to receive behavioral health services and dental services from their Healthy
            Louisiana managed care plan.</p>
          <!-- </div> -->
      </div>
      <div class="col-2 "></div>
    </div>
    </header>
    <br />

    <main >
      <app-laform  [preference]="preference"
        [errorMessageIntialData]="errorMessageIntialData" [email]="email" [address]="address" [emailTo]="emailTo"
        [faxNo]="faxNo" [tollfreeNo]="tollfreeNo"></app-laform>
    </main>
    <br />
    <footer class="text-center bg-light " >


        <p>
          Email <a target="_blank" [href]="emailTo" alt="Email" title="email" lang="en" style="color: #064EBA;">{{email}}</a> |
          Fax {{faxNo}} | Phone {{tollfreeNo}} | Mail to {{address}}
        </p>

        <div class="text-dark  p-3 bg-secondary bg-opacity-50 bg-gradient">HMS, Inc. All Rights Reserved</div>

    </footer>
    <la-app-scroll-top></la-app-scroll-top>

